import { ApiEntity } from '@app/entities/api.entity';
import { environment } from '@environment';

export const topZonesApi: ApiEntity = {
  data: {
    url: `${environment.api.travel_static_content}/zones/searchByNames`,
  }
};
